import React from 'react'
import { Link } from 'react-router-dom';
import google from '../../assets/google1.svg'
import bizimg from '../../assets/bizvecimg.svg'

const BizSignUpComp = () => {
  return (
    <>
<div className='container md:w-[60%] w-[90%] mt-10 mx-auto '>
                <div>
                    <div className='login-bg  rounded-xl mx-auto'>
                        <h1 className='text-center py-3 text-[56px] font-bold text-white  ' >Business Sign up</h1>
                    </div>
                      <div className='w-[90%] my-8 md:w-[70%] mx-auto'>

                        <form>
                         
                            <div class="mb-6">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-gray-700  ">Your Name</label>
                                <input type="email" id="number" class="shadow-sm px-5 h-[50px] border border-gray-300 text-gray-900 text-xs rounded-2xl bg-[#FBFEFF] h-[50px] focus:bg-white focus:ring-blue-500   block w-full p-2.5      " placeholder="Enter your name" required />
                            </div>
                            <div class="mb-6">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-gray-700  ">Company Name</label>
                                <input type="email" id="number" class="shadow-sm px-5 h-[50px] border border-gray-300 text-gray-900 text-xs rounded-2xl bg-[#FBFEFF] h-[50px] focus:bg-white focus:ring-blue-500   block w-full p-2.5      " placeholder="Enter company name" required />
                            </div>
                            <div class="mb-6">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-gray-700  ">Company email address</label>
                                <input type="email" id="number" class="shadow-sm px-5 h-[50px] border border-gray-300 text-gray-900 text-xs rounded-2xl bg-[#FBFEFF] h-[50px] focus:bg-white focus:ring-blue-500   block w-full p-2.5      " placeholder="Enter company email address" required />
                            </div>
                            <div class="mb-6">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-gray-700  ">Company website</label>
                                <input type="email" id="number" class="shadow-sm px-5 h-[50px] border border-gray-300 text-gray-900 text-xs rounded-2xl bg-[#FBFEFF] h-[50px] focus:bg-white focus:ring-blue-500   block w-full p-2.5      " placeholder="Enter company website" required />
                            </div>
                            <div class="mb-6">
                                <label htmlFor="email" class="block mb-2 text-xs font-medium text-gray-700  ">Email address</label>
                                <input type="email" id="email" class="shadow-sm px-5 h-[50px] rounded-2xl bg-[#FBFEFF] h-[50px] border border-gray-300 text-gray-900 text-xs  focus:ring-blue-500 focus:bg-white  block w-full p-2.5     " placeholder="(000) 000-00000" required />
                            </div>
                            <div class="mb-6">
                                <label htmlFor="rep" class="block mb-2 text-xs font-medium text-gray-700  ">Representative contact number</label>
                                <input type="text" id="rep" class="shadow-sm px-5 h-[50px] border border-gray-300 text-gray-900 text-xs rounded-2xl bg-[#FBFEFF] h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />
                            </div>
                            <div class="mb-6">
                            <label   class="block  mb-2 text-xs font-medium text-gray-700  ">Upload company logo </label>
                                <label htmlFor="bizimg" class="block py-6 rounded-xl border-2 border-gray-300 h-[100px] w-[124px]  mb-2 text-xs font-medium text-gray-700  "> 
                                <input type="file" id="bizimg" class="shadow-sm px-5 hidden h-[50px] border border-gray-300 text-gray-900 text-xs rounded-2xl bg-[#FBFEFF] h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />
                                <img src={bizimg} className='mx-auto h-[15px] w-[17px]' alt='uplaod image' /> 
                                <h5 className='text-[12px] text-[#6A7D95] text-center py-2' >Upto 00*00 resolution image</h5>
                                </label>
                            </div>
                            <div class="mb-6">
                                <label htmlFor="password" class="block mb-2 text-xs font-medium text-gray-700  ">About company</label>
                                <textarea id="w3review" className='shadow-sm px-5  rounded-lg border border-gray-300 text-gray-900 text-xs  bg-[#FBFEFF]   w-full p-2.5 focus:bg-white  ' name="w3review" rows="6" cols="50">

                               </textarea>
                            </div>
                            


                            <center>
                                <button type="submit" class="text-white my-6  bg-blue-400 hover:bg-blue-500    font-medium rounded-xl text-xs px-16 h-[50px] text-center  ">Sign Up</button>
                            </center>
                        </form>
                    </div>

                </div>
            </div>
    </>
  )
}

export default BizSignUpComp